import PageWrapper from "../../shared/wizard/PageWrapper";
import { expandedStates, states } from "../../../constants/data";
import Styles from "../AnonForms.module.css";
import { vehicleLocationType, vehicleMakes, vehicleOwnerOptions, yesNo } from "../../../constants/options";

function TheVehicle({
  fields,
  utilities,
}) {

  const {
    createToggleInput,
    createNoLabelSelect,
    createNoLabelInput,
    createWizSelect,
    createTextArea,
    createWizInput,
  } = utilities;

  return (
    <PageWrapper legendInfo="Your Vehicle:">
      <div className={Styles.inputContainer}>
        {createToggleInput(fields.vehicleIs, "60%", vehicleOwnerOptions, true)}
      </div>
      <div className={Styles.labelInputContainer}>
        <p className={Styles.sectionLabel}>Vehicle Information</p>
        <div className={Styles.formRow}>
          {createNoLabelInput(fields.vehicleYear, "70%", Styles.anonInput)}
          {createNoLabelSelect(
            fields.vehicleMake,
            "100%",
            vehicleMakes.map(make => make.name),
            Styles.anonSelect,
            "Select a make"
            )}
          {createNoLabelInput(fields.vehicleModel, "100%", Styles.anonInput)}
        </div>

        <div className={Styles.formRow}>
          {createNoLabelInput(fields.vehicleVin, "100%", Styles.anonInput)}
        </div>
        <div className={Styles.formRow}>
          <div className={Styles.labelInputContainer}>
            {createWizSelect(fields.currentLocation, "100%", vehicleLocationType, Styles.anonSelect)}
          </div>
        </div>
        <div>
          <div className={Styles.formRow}>
            {createNoLabelInput(fields.currentLocationVehicleAddress, "100%", Styles.anonInput)}
          </div>
          <div className={Styles.formRow}>
            {createNoLabelInput(fields.currentLocationVehicleCity, "100%", Styles.anonInput)}
            {createNoLabelSelect(
              fields.currentLocationVehicleState,
              "100%",
              expandedStates.map(state => state.Abbr),
              Styles.anonSelect,
              "Select a state"
              )}
            {createNoLabelInput(fields.currentLocationVehicleZip, "100%", Styles.anonInput)}
          </div>
        </div>
        <div
          className={Styles.textAreaContainer}
          style={{ alignItems: "flex-start" }}
        >
          {createTextArea(fields.vehicleDescribe, "100%", true, Styles.damageText)}
        </div>

        <div className={Styles.formRow}>
          {createWizInput(fields.vehicleEstimateDamage, "15rem", `${Styles.estimate} ${Styles.anonInput}`)}
        </div>
        {createToggleInput(fields.vehicleDriveable, "50%", yesNo, true)}
      </div>
      {
      fields.vehicleIs.value !== vehicleOwnerOptions[0].value && (
        <div className={`${Styles.fadeIn} ${Styles.labelInputContainer}`}>
          <p className={Styles.sectionLabel}>Vehicle Owner's Information</p>
          <div className={Styles.formRow}>
            <div className={Styles.isRow}>
              {
              fields.vehicleIs.value === vehicleOwnerOptions[1].value
              ? (
                <>
                {createNoLabelInput(fields.rentalCompanyName, "100%", Styles.anonInput)}
                </>
              ) : (
                <>
                {createNoLabelInput(fields.ownedFirstName, "50%", Styles.anonInput)}
                {createNoLabelInput(fields.ownedLastName, "50%", Styles.anonInput)}
                </>
              )}
            </div>
          </div>
          <div className={Styles.formRow}>
            {createNoLabelInput(fields.nonPolicyVehicleAddress, "50%", Styles.anonInput)}
            {createNoLabelInput(fields.nonPolicyVehicleCity, "50%", Styles.anonInput)}
          </div>

          <div className={Styles.formRow}>
            {createNoLabelSelect(fields.nonPolicyVehicleState, "100%", states, Styles.anonSelect, "Select a State")}
            {createNoLabelInput(fields.nonPolicyVehicleZipCode, "100%", Styles.anonInput)}
            {createNoLabelInput(fields.nonPolicyVehiclePhone, "100%", Styles.anonInput)}
          </div>
        </div>
      )}
    </PageWrapper>
  );
}

export default TheVehicle;
